<template>
  <div class="v-layout div_relative">
    <div class="select-wrapper" @click="($event) => showDropdown($event)">
      <div class="status-icon mr-1 ml-1"
           :class="{'online' : value === $c.USER_ONLINE_STATUS.ONLINE,
                  'offline' : value === $c.USER_ONLINE_STATUS.OFFLINE,
                  'busy' : value === $c.USER_ONLINE_STATUS.BUSY,}" />
      <label style="flex: 1; line-height: 16px;" class="mr-1 lbl_default2_1">{{$c.USER_STATUS_CATEGORY[value]}}</label>
      <img src="/assets/new/ic_offline.png" style="width: 10px; height: 8px; margin-right: 4px;" />
    </div>
    <div class="dropdown-wrapper" v-show="isDropdownShow">
      <div class="dropdown-item h-layout align-items-center" :class="{'selected' : cat === value}"
           @click="onSelectItem(cat)"
           v-for="cat in $c.USER_ONLINE_STATUS">
        <div class="status-icon mr-1 ml-2"
             :class="{'online' : cat === $c.USER_ONLINE_STATUS.ONLINE,
                      'offline' : cat === $c.USER_ONLINE_STATUS.OFFLINE,
                      'busy' : cat === $c.USER_ONLINE_STATUS.BUSY,}" />
        <label class="lbl_default2">{{$c.USER_STATUS_CATEGORY[cat]}}</label>
        <div class="ml-1" style="width: 5px;" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserStatusSelect",
  props:{
    value:{
      type:String,
      default:'OFF',
    }
  },
  data() {
    return {
      isDropdownShow: false,
      // styleObject: {
      //   left: 0,
      //   top: 0
      // }
    }
  },
  mounted() {
  },
  methods: {
    showDropdown(event) {
      // let offsetTop = this.$el.querySelector('.select-wrapper').getBoundingClientRect().bottom;
      // let offsetLeft = this.$el.querySelector('.select-wrapper').getBoundingClientRect().left;
      // this.styleObject.top = offsetTop + 2 + 'px';
      // this.styleObject.left = offsetLeft + 'px';
      this.isDropdownShow = !this.isDropdownShow;
    },
    onSelectItem(val) {
      this.$emit('input', val);
      this.isDropdownShow = false;
    }
  }
}
</script>

<style scoped lang="scss">
  .select-wrapper {
    background-color: white;
    color: black;
    border-radius: 12px;
    padding: 2px 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    //box-shadow: 0 3px 7px 0 rgba(0,0,0,0.7);
    min-width: 80px;
  }
  .dropdown-wrapper {
    z-index: 100;
    position: absolute;
    background-color: white;
    border-radius: 10px;
    color: #4a5764;
    top: 24px;
    padding: 3px 0;
    box-shadow: 0 3px 7px 0 rgba(0,0,0,0.7);
    min-width: 80px;
    overflow: hidden;
  }
  .dropdown-item {
    margin: 2px 0;
    //padding: 0 15px;
    text-align: center;
  }
  .dropdown-item.selected {
    background-color: $light_grey_1;
  }
  .status-icon {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .status-icon.online {
    background-color: #3DF2AD;
  }
  .status-icon.offline {
    background-color: $light-grey_1;
  }
  .status-icon.busy {
    background-color: darkred;
  }
</style>